const SRC = { England: "/flags/gb-eng.svg", Wales: "/flags/gb-wls.svg", Scotland: "/flags/gb-sct.svg" };

export default function Flag({ nation, className = "h-4 w-6" }) {
  return <img src={SRC[nation]} alt={`${nation} flag`} className={`${className} inline-block rounded-[3px] object-cover shadow-sm ring-1 ring-black/10`} />;
}
